import { createReducer, on } from '@ngrx/store';
import { Flow, FlowModeState } from '../../../shared/models/state/Flow';
import { NodeObject, nodeTypes } from '../../../shared/utils/nodeTypes';
import {
    addNodeType,
    flowModeAction,
    flowMetaDataAction,
    setChatHubProvidersAction,
    resetNodeType, setPermissions
} from '../actions/flow.action';

const initialState: Flow = {
    flowModeState: FlowModeState.FLOW_MODE,
    flowMetaData: null,
    nodeTypes: nodeTypes,
    permissions: undefined
}

/* Creating a reducer for the flowModeAction. */
export const flowModeReducer = createReducer(
    initialState,
    on(flowModeAction, (state, { flowModeState }) => {
        return {
            ...state,
            flowModeState
        };
    }),
    on(flowMetaDataAction, (state,{ flowMetaData }) =>{
        return {
            ...state,
            flowMetaData: flowMetaData
        };
    }),
    on(setChatHubProvidersAction, (state, { chatHubProviders }) => {
        return {
            ...state,
            nodeTypes: {
                ...state.nodeTypes,
                chathubNodes: chatHubProviders
            }
        }
    }),
    on(addNodeType, (state, { nodeObject, nodeName }) => {
        // Don`t really need this but will leave it for just in case.
        const exist = state.nodeTypes[nodeName].filter( (node: NodeObject) => node.nodeType === nodeObject.nodeType)
        if (exist.length > 0) {
            return state
        }
        return {
            ...state,
            nodeTypes: {
                ...state.nodeTypes,
                [nodeName]: [...state.nodeTypes[nodeName], nodeObject]
            }
        }
    }),
    on(resetNodeType, (state) => {
        return {
            ...state,
            nodeTypes
        }
    }),
    on(setPermissions, (state, { permissions }) => {
        return {
            ...state,
            permissions
        }
    })
);
